import { Card, Form, Radio, Typography } from "antd";
import styled from "styled-components";
import { FluxoPeriodo } from "../cadastroCotaUsuario.types";
import { DESTINACAO_OPTIONS, formatPeriodoLabel } from "../utils";

interface Props {
  index: number;
  periodo: FluxoPeriodo;
  fieldName: number;
  namePathPrefix?: Array<string | number>;
  solicitarDestinacao: boolean;
}

const PeriodoRadioGroup = styled(Radio.Group)`
  .ant-radio-wrapper {
    align-items: center;
    min-height: 28px;
  }

  .ant-radio {
    top: 0;
  }

  .ant-radio-inner {
    width: 18px;
    height: 18px;
    border-width: 2px;
    border-color: #6d8790;
  }

  .ant-radio-checked .ant-radio-inner {
    border-color: #003644;
  }

  .ant-radio-inner::after {
    width: 10px;
    height: 10px;
    margin-block-start: -5px;
    margin-inline-start: -5px;
    background-color: #003644;
  }
`;

export function PeriodoCard({
  periodo,
  fieldName,
  namePathPrefix = [],
  solicitarDestinacao,
}: Props) {
  const form = Form.useFormInstance();
  const periodoId = periodo.periodoId ?? periodo.id;
  const receberOportunidadesPath = [
    ...namePathPrefix,
    fieldName,
    "receberOportunidades",
  ];
  const destinacaoPath = [...namePathPrefix, fieldName, "destinacao"];
  const receberOportunidades = Form.useWatch(receberOportunidadesPath, form);

  return (
    <Card
      size="small"
      style={{ borderRadius: 18, borderColor: "#d9e4e8", marginBottom: 16 }}
    >
      <Typography.Title level={4} style={{ margin: "0 0 20px", color: "#003644" }}>
        {formatPeriodoLabel(periodo.checkIn, periodo.checkOut)}
      </Typography.Title>

      <Form.Item
        name={[...namePathPrefix, fieldName, "periodoId"]}
        hidden
        initialValue={periodoId}
      >
        <input type="hidden" />
      </Form.Item>

      {periodo.editavel === false ? (
        <Typography.Text type="secondary">
          Este período não pode ser alterado.
        </Typography.Text>
      ) : solicitarDestinacao ? (
        <>
          <Form.Item
            label="Gostaria de receber oportunidades de aluguel ou troca para este período?"
            name={receberOportunidadesPath}
            rules={[{ required: true, message: "Selecione uma opção." }]}
          >
            <PeriodoRadioGroup
              options={[
                { label: "Sim", value: true },
                { label: "Não", value: false },
              ]}
              onChange={(event) =>
                form.setFieldValue(
                  destinacaoPath,
                  event.target.value ? "OPORTUNIDADES_MULTICOTAS" : undefined
                )
              }
            />
          </Form.Item>

          {receberOportunidades === false ? (
            <Form.Item
              label="O que pretende fazer com este período?"
              name={destinacaoPath}
              rules={[{ required: true, message: "Selecione a destinação." }]}
            >
              <PeriodoRadioGroup
                options={DESTINACAO_OPTIONS}
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                  gap: 8,
                }}
              />
            </Form.Item>
          ) : null}
        </>
      ) : null}
    </Card>
  );
}
